import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const deleteCollection = {
  name: "deleteCollection" as const,
  input: z.object({ id: z.string() }),
  output: zExt.coercedResult(z.object({})),
};
